import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'impressions',
        label: t('tools.live_url.traffic.chart.avgDailyImpressions'),
        icon: 'search',
        yAxisID: 'y3',
    },
    {
        key: 'ctr',
        label: t('tools.live_url.traffic.chart.avgCTR'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'position',
        label: t('tools.live_url.traffic.chart.position'),
        format: '0.0',
        yAxisID: 'y2',
        info: t('tools.live_url.traffic.chart.positionInfo'),
        icon: 'pagev-view',
    },
    {
        key: 'clicks',
        label: t('tools.live_url.traffic.chart.dailyClicks'),
        icon: 'clicks',
    },
];

export const TAGS = (t) => [
    {
        label: t('tools.live_url.traffic.tags.all'),
        id: 'all',
    },
    {
        label: t('tools.live_url.traffic.tags.web'),
        id: 'web',
    },
    {
        label: t('tools.live_url.traffic.tags.discover'),
        id: 'discover',
    },
    {
        label: t('tools.live_url.traffic.tags.googlenews'),
        id: 'googlenews',
    },
    {
        label: t('tools.live_url.traffic.tags.image'),
        id: 'image',
    },
    {
        label: t('tools.live_url.traffic.tags.news'),
        id: 'news',
    },
    {
        label: t('tools.live_url.traffic.tags.video'),
        id: 'video',
    },
];

export default keys;
